module.exports = __webpack_public_path__ + "static/media/Smoothie de Té Verde con Arándanos.ca08907f.webp";